/* eslint-disable */
import React from "react";
import { getPropertyFiles } from "../../../actions/appExpandedActions/properties";
import { connect } from "react-redux";
import DataTable from "../DataTable";
import { tablePresets } from "../DataTable/tablePresets";

const Files = ({ getPropertyFiles, propertyFiles, period }) => (
  <DataTable
    {...tablePresets.files}
    data={propertyFiles}
    fetchData={getPropertyFiles}
    period={period}
  />
);

const mapStateToProps = (state) => ({
  propertyFiles: state.appProperties.propertyFiles,
});

const mapDispatchToProps = (dispatch) => ({
  getPropertyFiles: (payload) => dispatch(getPropertyFiles(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Files);
